import { featureRoute } from '../../../../src/routes/helpers';
import { CompensationPages } from '../../../../src/constants/AppConstants';

export default featureRoute('enableCompensationSeason', CompensationPages.SEASON, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/compensation/Season').default);
        }, 'compensation-season');
    }
});
